import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { fieldFilter } from '../FieldFilter';
import { categoryFilter } from '../CategoryFilter';
import { product } from '../Product';

const body = z
    .object({
        productIds: z.array(z.string()),
        minPrice: z.number().int().optional(),
        maxPrice: z.number().int().optional(),
        maxGroupSize: z.number().int().positive().max(20),
        maxGroups: z.number().int().positive().max(8),
        sortBy: z.enum(['relevance', 'price-asc', 'price-desc']),
        appliedFieldFilters: z.array(fieldFilter)
    })
    .strict();

export const productSearchCombinationsRefinementResult = z
    .object({
        groups: z.array(
            z.object({
                categoryFilter,
                products: z.array(product),
                totalQuantity: z.number().int().nonnegative()
            })
        )
    })
    .strict();

export const productSearchCombinationsRefinement = {
    verb: 'post',
    path: 'search-combinations-refinement',
    schema: {
        body,
        response: {
            200: productSearchCombinationsRefinementResult
        }
    }
} as const satisfies EndpointContract;

export type ProductSearchCombinationsRefinementResult = z.TypeOf<
    typeof productSearchCombinationsRefinementResult
>;
